import AreaSeries from "./AreaSeries";
import LineSeries from "./LineSeries";
import CompareSeries from "./CompareSeries";
import CandlestickSeries from "./CandlestickSeries";
import HistogramSeries from "./HistogramSeries";
import KagiSeries from "./KagiSeries";
import PointAndFigureSeries from "./PointAndFigureSeries";
import RenkoSeries from "./RenkoSeries";
import MACDSeries from "./MACDSeries";
import BollingerSeries from "./BollingerSeries";
import RSISeries from "./RSISeries";
import StochasticSeries from "./StochasticSeries";

import Area from "./Area";
import Line from "./Line";
import StraightLine from "./StraightLine";

import wrap from "./wrap";

export default {
	AreaSeries,
	LineSeries,
	CompareSeries,
	CandlestickSeries,
	HistogramSeries,
	KagiSeries,
	PointAndFigureSeries,
	RenkoSeries,
	MACDSeries,
	BollingerSeries,
	RSISeries,
	StochasticSeries,
	Area,
	Line,
	StraightLine,
	wrap,
};



/** WEBPACK FOOTER **
 ** /c/Ragu/Work/GC/opensource/react-stockcharts/src/lib/series/index.js
 **/